// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Righteous&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-wrapper[data-v-208b75b8]{margin-top:24px}.logo-wrapper>a[data-v-208b75b8]{text-decoration:none}.logo[data-v-208b75b8]{display:inline-block;font-family:\"Righteous\",sans-serif;font-style:normal;font-weight:400;font-size:36px;color:#747474;margin-left:16px;vertical-align:top;height:52px}.logo>span[data-v-208b75b8]{color:#a7d9dd}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
